<template>
  <v-dialog v-model="isOpen" persistent scrollable max-width="500">
    <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
      <v-card>
        <v-progress-linear
          v-if="isLoading"
          indeterminate
          color="primary"
          rounded
          height="6"
        ></v-progress-linear>

        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Cambiar Estatus
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text class="mb-5">
            <v-form>
              <v-row>
                <v-col cols="12" v-if="numberSelected">
                  <v-card-text class="py-0">
                    Numero de tlf
                  </v-card-text>
                  <v-text-field
                    v-model="numberSelected"
                    filled
                    rounded
                    disabled
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pb-0 pt-2">
                  <v-card-text class="py-0">
                    Estado
                  </v-card-text>
                  <ValidationProvider
                    name="Estado"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-select
                      v-model="payload.status_register_id"
                      :items="statusList"
                      :error-messages="errors"
                      item-text="name"
                      item-value="id"
                      filled
                      rounded
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" class="py-0 pt-4">
                  <v-card-text class="py-0">
                    Valor
                  </v-card-text>
                  <v-text-field
                    v-model="payload.value"
                    :disabled="isLoading"
                    label="Valor"
                    filled
                    rounded
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pb-0 pt-0">
                  <v-card-text class="py-0">
                    Comentarios
                  </v-card-text>
                  <v-textarea
                    v-model="payload.description"
                    filled
                    rounded
                    dense
                    rows="3"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="closeDialog()"
            >
              Cancelar
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="handleSubmit(submitForm)"
            >
              Actualizar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import vuescroll from "vuescroll";
export default {
  props: {
    isOpen: {
      type: Boolean,
    },
    dataToEdit: {
      type: Object,
    },
    numberSelected: {
      type: Number,
    },
    campaignId: {
      type: Number,
    },
    statusList: {
      type: Array,
    },
  },
  components: { vuescroll },

  data() {
    return {
      isLoading: false,
      payload: { ...this.dataToEdit },
    };
  },
  methods: {
    closeDialog(data = { status: false, id: this.payload.campaign_id }) {
      //   console.log("modal", this.payload);
      this.$emit("dialog:change", data);
    },
    async submitForm() {
      this.isLoading = true;
      try {
        let { id, ...payload } = this.payload;
        const { data } = await PbxHttpClient.put(
          `/campaign/register/${id}`,
          payload
        );
        this.payload.status = true;
        this.closeDialog(this.payload);
        this.$snotify.success("Estatus modificado con éxito.", "¡Hecho!");
      } catch (err) {
        // console.log("err", err);
        this.$snotify.error("Hubo un error modificando el estatus.", "¡Error!");
      }
      this.isLoading = false;
    },
  },
};
</script>

<style></style>
